<template>
    <b-modal
        ref="modal"
        title="Aviso"
        header-bg-variant="danger"
        header-text-variant="light"
        footer-bg-variant="light"
        cancel-title="Cancelar"
        :ok-title="okTitle"
        ok-variant="danger"
        :busy="busy"
        centered
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        no-fade
        @ok="confirm"
    >
        <template v-slot:default="{ visible }">
            <p>
                Deseja realmente apagar o usuário
                <strong v-if="visible">{{ user.username }}</strong
                >?
            </p>
            <b-alert :show="true" variant="warning" class="mb-0"
                >Esta operação não poderá ser desfeita.</b-alert
            >
        </template>
    </b-modal>
</template>

<script>
import sleep from "@/utils/sleep";

export default {
    name: "UsersDelete",
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            busy: false,
            okTitle: "Apagar"
        };
    },
    methods: {
        show() {
            this.$refs.modal.show();
        },
        async confirm(event) {
            event.preventDefault();
            const { username } = this.user;

            this.busy = true;
            this.okTitle = "Apagando usuário...";

            await sleep(500);

            await this.$store.dispatch("settings/users/deleteUser", this.user);
            this.okTitle = "Apagar";
            this.$bvToast.toast(`Usuário ${username} apagado com sucesso.`, {
                title: "Aviso",
                variant: "info",
                noCloseButton: true
            });
            this.$refs.modal.hide();
            this.busy = false;
        }
    }
};
</script>
